import { render, staticRenderFns } from "./TroveHeader.vue?vue&type=template&id=b02adf5a&scoped=true&"
import script from "./TroveHeader.vue?vue&type=script&lang=js&"
export * from "./TroveHeader.vue?vue&type=script&lang=js&"
import style0 from "./TroveHeader.vue?vue&type=style&index=0&id=b02adf5a&prod&lang=scss&"
import style1 from "./TroveHeader.vue?vue&type=style&index=1&id=b02adf5a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b02adf5a",
  null
  
)

export default component.exports